import { Icon, Tooltip } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { getColor } from "utils/colors";

const getRows = (data) => {
  const rows = [];
  if (data) {
    data.forEach((item) => {
      rows.push({
        desde: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="black"
              fontWeight="medium"
            >
              {item?.desde}
            </SoftTypography>
          </SoftBox>
        ),
        hasta: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="black"
              fontWeight="medium"
            >
              {item?.hasta}
            </SoftTypography>
          </SoftBox>
        ),
        observaciones: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="black"
              fontWeight="medium"
            >
              {item?.observaciones ? item.observaciones : "-"}
            </SoftTypography>
          </SoftBox>
        ),
      });
    });
  }

  return rows;
};

const columns = [
  { name: "desde", desc: "Desde", align: "center", noOrder: true, width: "25%" },
  { name: "hasta", desc: "Hasta", align: "center", noOrder: true, width: "25%" },
  { name: "observaciones", desc: "Observaciones", align: "center", noOrder: true, width: "1%" },
];

export default { columns, getRows };
